module.exports = __webpack_public_path__ + "img/zero-logo-light.3c963d4c.svg";